import React from 'react';
import { Award, Users, Shield, GraduationCap } from 'lucide-react';
import { trustStats } from '../data/mockData';

const iconMap = {
  Award: Award,
  Users: Users,
  Shield: Shield,
  GraduationCap: GraduationCap
};

const TrustStrip = () => {
  return (
    <section className="py-12 bg-gradient-to-r from-blue-600 via-blue-700 to-blue-600 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
          backgroundSize: '30px 30px'
        }}></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 max-w-5xl mx-auto">
          {trustStats.map((stat, index) => {
            const IconComponent = iconMap[stat.icon];
            return (
              <div 
                key={index}
                className="text-center group hover-lift"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="flex justify-center mb-3">
                  <div className="w-14 h-14 md:w-16 md:h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center group-hover:bg-white/30 transition-all duration-300">
                    <IconComponent className="w-7 h-7 md:w-8 md:h-8 text-white" />
                  </div>
                </div>
                <h3 className="text-3xl md:text-4xl font-bold text-white mb-1">{stat.number}</h3>
                <p className="text-sm md:text-base text-white/90 font-medium">{stat.label}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustStrip;